import { render, staticRenderFns } from "./NormalSearchNav127.vue?vue&type=template&id=0b8c21ca&scoped=true"
import script from "./NormalSearchNav127.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav127.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c21ca",
  null
  
)

export default component.exports